import config from 'services/table/const';
import Action from './table.action';

let table = { ...config };

table.url = '/schema/kurir';
table.columns = {
  weight_less: {
    title: 'Berat (Kg)',
    sortable: true,
    format_number: false,
    width: 100,
    class: '',
    component: (row) => {
      return <div className="text-ellipsis">{row?.weight_less}</div>;
    },
  },
  point: {
    title: 'Jumlah Poin',
    sortable: true,
    format_number: false,
    width: 100,
    class: '',
    component: (row) => {
      return <div className="text-ellipsis">{row?.point}</div>;
    },
  },
  action: {
    title: '',
    width: 70,
    class: 'text-end',
    component: (row) => {
      return <Action data={row} />;
    },
  },
};

export default table;
